import React from 'react'

import Typography from 'components/atoms/Typography'
import Container from 'components/atoms/Container'
import AuthenticatedLink from 'components/molecules/AuthenticatedLink'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import AptitudeTestimonies from 'components/organisms/AptitudeTestimonies'

const AptitudeEmptyPlaceholder = () => (
  <div className="aptitude-empty">
    <Container>
      <Row>
        <Col md={{ size: 10, offset: 1 }}>
          <Typography
            component="h1"
            variant="title"
            className="aptitude-empty__title text-variant-title-sm"
          >
            Kamu belum mengikuti Tes Minat Bakat!
          </Typography>
          <div className="aptitude-empty__description">
            <Typography component="p" variant="body">
              <span className="bold">81.551 siswa</span> dari <span className="bold">5.489 sekolah</span> telah menemukan jurusan dan karier yang cocok melalui Tes Minat Bakat Quipper Campus. Sekarang giliran kamu, yuk coba sekarang dan lihat langsung hasilnya!
            </Typography>
          </div>
        </Col>
      </Row>
    </Container>
    <AptitudeTestimonies/>
    <Container>
      <div className="aptitude-empty__new-test">
        <AuthenticatedLink href="/aptitude_test/instruction" className="button button-default aptitude-empty__new-test-btn">
          Coba Gratis Sekarang
        </AuthenticatedLink>
      </div>
    </Container>

    <style jsx>
      {`
        .aptitude-empty {
          padding: 40px 0 80px;
          :global(&__title),
          &__description {
            text-align: center;
          }
          &__new-test {
            text-align: center;
            margin-top: 32px;
          }
          :global(&__new-test-btn) {
            font-weight: bold;
            padding: 12px 24px;
          }
          .bold {
            font-weight: bold;
          }
        }
      `}
    </style>
  </div>
)

export default AptitudeEmptyPlaceholder
